import { Typography } from "@mui/material";
import maintenance from "assets/animations/maintenance.json" with { type: "json" };
import { ModalContentWrapper } from "components/primitives/ModalContentWrapper";
import { ModalTitle } from "components/primitives/ModalTitle";
import { useMixpanelTrackers } from "hooks/useMixpanelTrackers";
import { useAppSelector } from "hooks/utilsHooks/storeHooks";
import Lottie from "lottie-react";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { selectShortFridgeId } from "slices/fridgeInfoSlice";
import { logToSentry } from "utils/logger";
import { BasicModal } from "./BasicModal";

const StartingUpModalContent = () => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();
	const { trackStartingUpModal } = useMixpanelTrackers();
	const trackRef = useRef(trackStartingUpModal);
	trackRef.current = trackStartingUpModal;

	useEffect(() => {
		trackRef.current("open");
		logToSentry(`Starting up modal displayed on fridge: ${fridgeId}`, "info");
		return () => {
			trackRef.current("close");
		};
	}, [fridgeId]);

	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{t("modals.startingUpModal.title")}</ModalTitle>
			<Typography variant="promoText" sx={{ marginRight: "auto", marginBottom: 10 }}>
				{t("modals.startingUpModal.description")}
			</Typography>
			<Lottie animationData={maintenance} loop={true} />
		</ModalContentWrapper>
	);
};

export const StartingUpModal = () => (
	<BasicModal modalContent={<StartingUpModalContent />} open={true} closable={false} fullHeight={true} />
);
